export default __webpack_public_path__ + "static/icon-22-4-16402c33aa26d739ae6f25741a04aa14.png";